<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
}

.el-progress__text {
  /* display: none; */
  font-size: 12px !important;
}
/* .el-progress-bar__outer{
  background: #D9D9D9;
}
.el-progress-bar{
  padding-right: 0;
  margin-right: 0;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue